module.exports = __webpack_public_path__ + "img/78cb37057d94a2a9304e7e25060fb63f.png";